import {put, select, takeEvery} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {
  getLocationNotificationsApi,
  patchLocationApi,
  postTestOrder,
  getOrderApi,
  getCloudPrintConfigurationsApi,
  updateCloudPrintConfigurationsApi,
  postOrderApi,
  postHistoryOrdersApi
} from 'helpers/services/api/ordersV2';
import {
  CHANGE_ORDER_INFO,
  GET_ORDER,
  GET_ORDERS,
  SET_NEXT_PAGE,
  CHANGE_STATUS_HISTORY,
  CHANGE_STATUS_HISTORY_SUCCESS,
  GET_LOCATION_ID_DATA,
  GET_LOCATION_ID_DATA_SUCCESS,
  PATCH_LOCATION_ACTION,
  SEND_TEST_ORDER,
  SEND_TEST_ORDER_SUCCESS,
  REFRESH_ORDERS,
  SET_ORDERS,
  GET_ORDER_SUCCESS,
  SET_ORDERS_EMPTY,
  TURN_OFF_COMPLETED_NOTIFICATION,
  OPEN_STATUS_CHANGE_MODAL,
  GET_CLOUD_PRINT_CONFIGURATIONS_SUCCESS,
  GET_CLOUD_PRINT_CONFIGURATIONS,
  UPDATE_CLOUD_PRINT_CONFIGURATIONS
} from 'store/ordersV2/orderList/action';
import {
  ORDER,
  ORDER_CANCELLATION_STATUS,
  ORDER_MISC_MANY,
  ORDER_PAYMENT_METHOD,
  ORDER_SOURCE,
  ORDER_STATUS,
  ORDER_TYPE,
  ORDER_TYPES
} from 'helpers/constants/orders_v2';
import {
  API_ORDER_INFO,
  API_ORDERS
} from 'helpers/services/constants/API_ENDPOINTS';
import {request} from 'helpers/services/utils/request';
import {GET, PUT} from 'helpers/services/constants/API_CONSTANTS';
import {GET_USER_DATA} from 'store/global/user/action';
import {
  RUN_GET_ACTIVE_ORDERS_JOB,
  STOP_GET_ACTIVE_ORDERS_JOB
} from 'store/global/ordersV2/action';
import userId from 'store/global/user/selectors';
import {patchUsersApi} from 'helpers/services/api/user';
import camelize from 'helpers/functionUtils/camelize';
import {OPEN_CANCELLATION_REFUND_MODAL} from 'store/global/ordersV2/CancellationRefund/action';
import {
  OPEN_CANCELLATION_CONFIRMATION_MODAL_V2,
  SET_LOADING_CANCELLATION_V2
} from 'store/global/modals/action';
import moment from 'moment';

export function* getOrders({payload}) {
  try {
    const {
      orders,
      filter: {
        startDate,
        endDate,
        orderSource,
        orderTypes,
        orderMiscMany,
        orderPaymentsMethods
      },
      page,
      limit,
      sorting: {sort, sortBy},
      search
    } = yield select((state) => state.ordersHistoryV2Reducer);
    const {Timezone, _id} = yield select((state) => state.user.activeLocation);

    const {data} = yield postHistoryOrdersApi(
      {
        ...(startDate && {startDate}),
        ...(endDate && {endDate}),
        pageNumber: page,
        sortDirection: sort,
        sortBy,
        pageSize: limit,
        searchText: search,
        filter: {
          orderTypes:
            orderTypes?.includes('All') || orderTypes?.length === 0
              ? null
              : orderTypes?.map((type) => camelize(type)),
          orderPaymentsMethods:
            orderPaymentsMethods?.includes('All') ||
            orderPaymentsMethods?.length === 0
              ? null
              : orderPaymentsMethods,
          orderSources:
            orderSource?.includes('All') || orderSource?.length === 0
              ? null
              : orderSource
        }
      },
      _id
    );

    if (data?.orders) {
      const newOrders = payload.isCustomerSearch
        ? data.orders
        : [...orders, ...data.orders];
      yield put(SET_ORDERS({data: newOrders, Timezone}));
      yield put(SET_NEXT_PAGE({...data, page}));
    }

    return data;
  } catch (error) {
    console.log('SAGA ERROR', error);
    return null;
  }
}

export function* changeStatus({payload: {id, status, previousStatus}}) {
  try {
    const completedOrderNotification = yield select(
      (state) => state.user?.userData?.ShowCompletedOrderNotification
    );

    const {data} = yield postOrderApi(id, {
      status,
      overdueDisabled: previousStatus === ORDER_STATUS.OVERDUE
    });
    if (data?.order[ORDER.ID]) {
      toast.success('Order status was changed!');
      if (
        previousStatus !== ORDER_STATUS.COMPLETED &&
        status === ORDER_STATUS.COMPLETED &&
        completedOrderNotification
      ) {
        yield put(OPEN_STATUS_CHANGE_MODAL(true));
      }
    }
    return data;
  } catch (error) {
    console.log('SAGA ERROR', error);
    return false;
  }
}

export function* changeStatusHistory({
  payload: {id, status, previousStatus},
  orderId = null
}) {
  try {
    yield put(SET_LOADING_CANCELLATION_V2(true));
    const data = yield changeStatus({payload: {id, status, previousStatus}});

    if (data && data?.order[ORDER.ID]) {
      if (
        data?.order[ORDER.ORDER_STATUS] === ORDER_STATUS.NEW ||
        data?.order[ORDER.ORDER_STATUS] === ORDER_STATUS.ACCEPTED
      ) {
        yield put(
          CHANGE_STATUS_HISTORY_SUCCESS({[ORDER.ID]: data?.order[ORDER.ID]})
        );
      } else if (data?.order[ORDER.ORDER_STATUS] === ORDER_STATUS.CANCELLED) {
        yield put(
          OPEN_CANCELLATION_CONFIRMATION_MODAL_V2({
            isOpen: false,
            info: null,
            source: null,
            deliveryId: null
          })
        );
        yield put(
          OPEN_CANCELLATION_REFUND_MODAL({
            isOpenModal: true,
            invoiceId:
              (!data?.order[ORDER.REFUND] ||
                !data?.order[ORDER.REFUND]?.find((el) => el.type === 'Full')) &&
              data?.order[ORDER.SOURCE] === ORDER_SOURCE.SAUCE
                ? data?.order[ORDER.INVOICE_ID]
                : null,
            showCannotDeliveryText:
              (data?.orderProviderResult?.status &&
                data?.orderProviderResult?.status !==
                  ORDER_CANCELLATION_STATUS.CANCELLED_SUCCESSFULLY) ||
              data?.orderProviderResult?.errorMessage,
            orderId
          })
        );
        yield put(
          CHANGE_STATUS_HISTORY_SUCCESS({
            [ORDER.ORDER_STATUS]: data?.order[ORDER.ORDER_STATUS],
            [ORDER.ID]: data?.order[ORDER.ID]
          })
        );
      } else {
        yield put(
          CHANGE_STATUS_HISTORY_SUCCESS({
            [ORDER.ORDER_STATUS]: data?.order[ORDER.ORDER_STATUS],
            [ORDER.ID]: data?.order[ORDER.ID]
          })
        );
      }
    }
    yield put(SET_LOADING_CANCELLATION_V2(false));
    return data?.order[ORDER.ORDER_STATUS];
  } catch (error) {
    yield put(SET_LOADING_CANCELLATION_V2(false));
    console.log('SAGA ERROR', error);
    return false;
  }
}

export function* refreshOrders(newOrders) {
  try {
    const {
      filter: {
        startDate,
        endDate,
        orderChannels,
        orderTypes,
        orderMiscMany,
        orderPaymentsMethods
      },
      total,
      limit,
      sorting: {sort, sortBy}
    } = yield select((state) => state.ordersHistoryV2Reducer);

    const {Timezone, _id} = yield select((state) => state.user.activeLocation);

    const {data} = yield postHistoryOrdersApi(
      {
        ...(startDate && {startDate}),
        ...(endDate && {endDate}),
        pageNumber: 1,
        sortDirection: sort,
        sortBy,
        pageSize: (total || limit) + newOrders.length,
        orderChannels: null,
        orderTypes: orderTypes?.includes('All')
          ? Object.values(ORDER_TYPE).filter((type) => type !== 'All')
          : orderTypes?.map((type) => camelize(type)),
        orderExtends: orderMiscMany?.includes('All')
          ? Object.values(ORDER_MISC_MANY).filter((type) => type !== 'All')
          : orderMiscMany?.map((type) => camelize(type)),
        orderPaymentsMethods: orderPaymentsMethods?.includes('All')
          ? Object.values(ORDER_PAYMENT_METHOD).filter((type) => type !== 'All')
          : orderPaymentsMethods?.map((type) => camelize(type))
      },
      _id
    );

    if (data?.orders?.length > 0) {
      yield put(SET_ORDERS({data: data.orders, Timezone}));
    }

    return data;
  } catch (error) {
    console.log('SAGA ERROR', error);
    return null;
  }
}

export function* getLocationNotificationsById() {
  try {
    const locationId = yield select((state) => state.user.locationId);
    const id = yield select(userId);

    const {data} = yield getLocationNotificationsApi(locationId, id);

    if (data) {
      yield put(GET_LOCATION_ID_DATA_SUCCESS(data));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

export function* getCloudPrintConfigurationsById() {
  try {
    const locationId = yield select((state) => state.user.locationId);

    const {data} = yield getCloudPrintConfigurationsApi(locationId);

    if (data) {
      yield put(GET_CLOUD_PRINT_CONFIGURATIONS_SUCCESS(data));
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

export function* updateCloudPrintConfigurationsById({
  payload: {values, onSuccess}
}) {
  try {
    const locationId = yield select((state) => state.user.locationId);

    const response = yield updateCloudPrintConfigurationsApi(
      locationId,
      values
    );

    if (response.status === 204) {
      toast.success('Cloud Print Configurations has been updated successfully');
      if (onSuccess) onSuccess();
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

export function* patchLocation({payload: {data, actions}}) {
  try {
    const locationId = yield select((state) => state.user.locationId);
    const id = yield select(userId);

    yield patchLocationApi({locationId, id, data});
    actions();
    toast.success('The update was successful!');
    yield put(GET_LOCATION_ID_DATA());
    yield put(GET_USER_DATA());
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

export function* sendTestOrder() {
  try {
    yield postTestOrder();
    yield put(SEND_TEST_ORDER_SUCCESS());
    yield put(STOP_GET_ACTIVE_ORDERS_JOB());
    yield put(RUN_GET_ACTIVE_ORDERS_JOB());
    toast.success('The test order has been created!');
  } catch (error) {
    yield put(SEND_TEST_ORDER_SUCCESS());
    console.log('SAGA ERROR', error);
  }
}

export function* changeInfo({payload: {id, note}}) {
  try {
    const res = yield request(PUT, API_ORDER_INFO(id), {data: {note}});

    if (res.status === 200) {
      toast.success('Order notes were changed!');
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

export function* getOrder({payload: {id, successCb}}) {
  try {
    const {data} = yield getOrderApi(id);

    if (data) {
      yield put(GET_ORDER_SUCCESS(data));
      successCb();
    }
  } catch (error) {
    console.log('SAGA ERROR', error);
  }
}

export function* turnOffCompletedStatusNotification({payload}) {
  try {
    const id = yield select((state) => state.user.userData.id);

    const {status} = yield patchUsersApi(id, {
      ShowCompletedOrderNotification: payload
    });

    if (status === 204) {
      yield put(GET_USER_DATA());
    }
  } catch (error) {
    toast.error(`Error occurred - please try again [${error}]`);
  }
}

function* orderListV2Saga() {
  yield takeEvery(GET_ORDERS, getOrders);
  yield takeEvery(CHANGE_STATUS_HISTORY, changeStatusHistory);
  yield takeEvery(REFRESH_ORDERS, refreshOrders);
  yield takeEvery(GET_LOCATION_ID_DATA, getLocationNotificationsById);
  yield takeEvery(PATCH_LOCATION_ACTION, patchLocation);
  yield takeEvery(SEND_TEST_ORDER, sendTestOrder);
  yield takeEvery(CHANGE_ORDER_INFO, changeInfo);
  yield takeEvery(GET_ORDER, getOrder);
  yield takeEvery(
    TURN_OFF_COMPLETED_NOTIFICATION,
    turnOffCompletedStatusNotification
  );
  yield takeEvery(
    GET_CLOUD_PRINT_CONFIGURATIONS,
    getCloudPrintConfigurationsById
  );
  yield takeEvery(
    UPDATE_CLOUD_PRINT_CONFIGURATIONS,
    updateCloudPrintConfigurationsById
  );
}

export default orderListV2Saga;
